import React, { Component } from "react";
import { Link } from "react-router-dom";
import "tachyons";
import "./Foooter.css";

class Foooter extends Component {
  render() {
    return (
      <div className="footer">
        <footer className="pv4 ph3 ph5-ns tc">
          <a
            className="link dim gray dib h2 w2 br-100 mr3 "
            href="https://www.facebook.com/aditya.babar.58323/"
            target="_blank"
            rel="noopener noreferrer"
            title=""
          >
            <svg
              data-icon="facebook"
              viewBox="0 0 32 32"
              style={{ fill: "currentcolor" }}
            >
              <title>facebook icon</title>
              <path d="M8 12 L13 12 L13 8 C13 2 17 1 24 2 L24 7 C20 7 19 7 19 10 L19 12 L24 12 L23 18 L19 18 L19 30 L13 30 L13 18 L8 18 z"></path>
            </svg>
          </a>
          <a
            className="link dim gray dib h2 w2 br-100 mr3 "
            href="https://www.twitter.com/adityababar20"
            target="_blank"
            rel="noopener noreferrer"
            title=""
          >
            <svg
              data-icon="twitter"
              viewBox="0 0 32 32"
              style={{ fill: "currentcolor" }}
            >
              <title>twitter icon</title>
              <path d="M2 4 C6 8 10 12 15 11 A6 6 0 0 1 22 4 A6 6 0 0 1 26 6 A8 8 0 0 0 31 4 A8 8 0 0 1 28 8 A8 8 0 0 0 32 7 A8 8 0 0 1 28 11 A18 18 0 0 1 10 30 A18 18 0 0 1 0 27 A12 12 0 0 0 8 24 A8 8 0 0 1 3 20 A8 8 0 0 0 6 19.5 A8 8 0 0 1 0 12 A8 8 0 0 0 3 13 A8 8 0 0 1 2 4"></path>
            </svg>
          </a>
          <a
            className="link dim gray dib br-100 h2 w2 mr3 "
            href="https://www.github.com/adityababar07"
            target="_blank"
            rel="noopener noreferrer"
            title=""
          >
            <svg
              data-icon="github"
              viewBox="0 0 32 32"
              style={{ fill: "currentcolor" }}
            >
              <title>github icon</title>
              <path d="M0 18 C0 12 3 10 3 9 C2.5 7 2.5 4 3 3 C6 3 9 5 10 6 C12 5 14 5 16 5 C18 5 20 5 22 6 C23 5 26 3 29 3 C29.5 4 29.5 7 29 9 C29 10 32 12 32 18 C32 25 30 30 16 30 C2 30 0 25 0 18 M3 20 C3 24 4 28 16 28 C28 28 29 24 29 20 C29 16 28 14 16 14 C4 14 3 16 3 20 M8 21 A1.5 2.5 0 0 0 13 21 A1.5 2.5 0 0 0 8 21 M24 21 A1.5 2.5 0 0 0 19 21 A1.5 2.5 0 0 0 24 21 z"></path>
            </svg>
          </a>
          <a
            className="link dim gray dib br-100 h2 w2 mr3 "
            href="https://www.instagram.com/_adityababar"
            target="_blank"
            rel="noopener noreferrer"
            title=""
          >
            <svg
              data-icon="instagram"
              style={{ fill: "currentcolor" }}
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              enableBackground="new 0 0 512 512"
              viewBox="0 0 511 511.9"
            >
              <title>instagram icon</title>
              <g>
                <path
                  xmlns="http://www.w3.org/2000/svg"
                  d="M510.95 150.5c-1.2-27.2-5.598-45.898-11.9-62.102-6.5-17.199-16.5-32.597-29.6-45.398-12.802-13-28.302-23.102-45.302-29.5-16.296-6.3-34.898-10.7-62.097-11.898C334.648.3 325.949 0 256.449 0s-78.199.3-105.5 1.5c-27.199 1.2-45.898 5.602-62.097 11.898-17.204 6.5-32.602 16.5-45.403 29.602-13 12.8-23.097 28.3-29.5 45.3-6.3 16.302-10.699 34.9-11.898 62.098C.75 177.801.449 186.5.449 256s.301 78.2 1.5 105.5c1.2 27.2 5.602 45.898 11.903 62.102 6.5 17.199 16.597 32.597 29.597 45.398 12.801 13 28.301 23.102 45.301 29.5 16.3 6.3 34.898 10.7 62.102 11.898 27.296 1.204 36 1.5 105.5 1.5s78.199-.296 105.5-1.5c27.199-1.199 45.898-5.597 62.097-11.898a130.934 130.934 0 0074.903-74.898c6.296-16.301 10.699-34.903 11.898-62.102 1.2-27.3 1.5-36 1.5-105.5s-.102-78.2-1.3-105.5zm-46.098 209c-1.102 25-5.301 38.5-8.801 47.5-8.602 22.3-26.301 40-48.602 48.602-9 3.5-22.597 7.699-47.5 8.796-27 1.204-35.097 1.5-103.398 1.5s-76.5-.296-103.403-1.5c-25-1.097-38.5-5.296-47.5-8.796C94.551 451.5 84.45 445 76.25 436.5c-8.5-8.3-15-18.3-19.102-29.398-3.5-9-7.699-22.602-8.796-47.5-1.204-27-1.5-35.102-1.5-103.403s.296-76.5 1.5-103.398c1.097-25 5.296-38.5 8.796-47.5C61.25 94.199 67.75 84.1 76.352 75.898c8.296-8.5 18.296-15 29.398-19.097 9-3.5 22.602-7.7 47.5-8.801 27-1.2 35.102-1.5 103.398-1.5 68.403 0 76.5.3 103.403 1.5 25 1.102 38.5 5.3 47.5 8.8 11.097 4.098 21.199 10.598 29.398 19.098 8.5 8.301 15 18.301 19.102 29.403 3.5 9 7.699 22.597 8.8 47.5 1.2 27 1.5 35.097 1.5 103.398s-.3 76.301-1.5 103.301zm0 0"
                  data-original="#000000"
                ></path>
                <path
                  xmlns="http://www.w3.org/2000/svg"
                  d="M256.45 124.5c-72.598 0-131.5 58.898-131.5 131.5s58.902 131.5 131.5 131.5c72.6 0 131.5-58.898 131.5-131.5s-58.9-131.5-131.5-131.5zm0 216.8c-47.098 0-85.302-38.198-85.302-85.3s38.204-85.3 85.301-85.3c47.102 0 85.301 38.198 85.301 85.3s-38.2 85.3-85.3 85.3zm0 0M423.852 119.3c0 16.954-13.747 30.7-30.704 30.7-16.953 0-30.699-13.746-30.699-30.7 0-16.956 13.746-30.698 30.7-30.698 16.956 0 30.703 13.742 30.703 30.699zm0 0"
                  data-original="#000000"
                ></path>
              </g>
            </svg>
          </a>
          <div className="mt4">
            <p>All copyrights @ adityababar</p>
            <Link
              exact
              to="/contact"
              className="f6 link dim gray dib mr3 mr4-ns"
            >
              Help
            </Link>
            <Link
              exact
              to="/contact"
              className="f6 link dim gray dib mr3 mr4-ns"
            >
              Send feedback
            </Link>
            <Link exact to="/" className="f6 link dim gray dib mr3 mr4-ns">
              Privacy
            </Link>
            <Link exact to="/" className="f6 link dim gray dib">
              Terms
            </Link>
          </div>
        </footer>
      </div>
    );
  }
}

export default Foooter;
